import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}

export const ModalInfoLogin: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false);
  };

  return (
    <Modal
      className="ant-modal-close-x2 modal-info-login-responsive"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144, 0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      centered
      width={680}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className="modal-info-title">
        Ingreso a la plataforma de estímulos
      </div>
      <div className="modal-info-content">
        <p className="mb-3">
          Para ingresar completa los siguientes pasos:
        </p>
        <p className="mb-2">
          <strong>1.</strong> Debe tener primero un usuario creado en el portal de Medellín:{" "}
          <a href="https://www.medellin.gov.co" target="_blank" rel="noopener noreferrer">
            www.medellin.gov.co
          </a>.
        </p>
        <p className="mb-2">
          <strong>2.</strong> Completar el perfil en{" "}
          <a
            href="https://www.medellin.gov.co/estimuloscultura/usuario/registrarUsuario"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.medellin.gov.co/estimuloscultura/usuario/registrarUsuario
          </a>.
        </p>
        <p className="mb-3">
          <strong>3.</strong> Ingresar a{" "}
          <a
            href="https://www.medellin.gov.co/estimuloscultura/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.medellin.gov.co/estimuloscultura/login
          </a>{" "}
          con el mismo usuario y clave del portal.
        </p>
        <div className="mt-4 pt-2 border-top text-muted" style={{ fontSize: "0.85rem" }}>
          Atentamente, <br />
          <strong>Equipo de Convocatorias de la Secretaría de Cultura Ciudadana</strong>
        </div>
      </div>
    </Modal>
  );
};
